export default "<div id=\"snackbar\">Some text some message..</div>\r\n"